import uploadService from './upload';

/**
 * Resolves the stored S3 file name for whatever an ImageInput is holding.
 *
 * - a freshly dropped file (`rawFile`) is uploaded to POST /api/file
 * - a media library selection or an existing record value (`{ picture }` or a bare
 *   file name string) is already in S3, so it is passed through untouched
 *
 * Always resolves to the `{ data: { fileName } }` shape the upload endpoint returns,
 * so callers can treat both paths the same way.
 */
const uploadPicture = (img, progressFunc = null) => {
  if (img && img.rawFile) {
    const formData = new FormData();
    formData.append('file', img.rawFile);
    return uploadService(formData, progressFunc);
  }
  if (img && img.picture) {
    return Promise.resolve({ data: { fileName: img.picture } });
  }
  if (typeof img === 'string' && img) {
    return Promise.resolve({ data: { fileName: img } });
  }
  return Promise.resolve({ data: { fileName: null } });
};

export default uploadPicture;
